<div class="flex flex-col gap-4" *transloco="let t">
  <div class="flex flex-col items-start">
    <label class="font-medium">{{ t(seedTypeKeys[modalData.seedType]) }}</label>
    @if (modalData.seedType === SeedType.Product) {
      <div class="col-sm-9">
        <app-product-view
          [asin]="modalData.targetingItemValue"
          [marketplace]="modalData.marketplace"
        ></app-product-view>
      </div>
    }
    @if (modalData.seedType === SeedType.Keyword) {
      <div class="w-[30rem] text-gray-800">
        <IBadge color="white" [label]="modalData.targetingItemValue" />
      </div>
    }
  </div>
  <div class="flex flex-col gap-2">
    <label class="font-medium">{{ t("add-to-seeds-modal.seed_blacklist") }}</label>
    <div>
      <ISelectMenu [value]="asinSeedType()" (valueChange)="onAsinSeedTypeChange($event)" fitTriggerWidth>
        <ISelectTrigger class="flex w-full">
          <ISelectValue>
            <div *iSelectValue="let value">{{ value | asinSeedTypeLabel }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (type of seedTypes; track type) {
            <ISelectOption [value]="type">
              {{ type | asinSeedTypeLabel }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
    @if (modalData.seedType === SeedType.Keyword && asinSeedType() === AsinSeedTypeEnum.WHITELIST) {
      <div class="flex justify-start">
        <ISwitchButton
          [options]="[MatchType.phrase, MatchType.exact]"
          [buttonTexts]="['common.phrase', 'common.exact']"
          [buttonTooltips]="['', '']"
          [selected]="matchType"
          (buttonClicked)="setMatchType($event)"
        />
      </div>
    }
  </div>
  <div class="flex flex-col gap-2">
    <label class="font-medium">{{ t("common.for_asins") }}</label>
    <div>
      <app-product-view [asin]="modalData.asin" [marketplace]="modalData.marketplace"></app-product-view>
    </div>
  </div>
  <div class="flex justify-end gap-x-2">
    <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>

    <button iButton type="submit" size="md" (click)="save()">{{ t("common.save") }}</button>
  </div>
</div>
